import TableTemplate from "../../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../../TableTemplate/common";
import { getExeStatusOrdersErrorsTable } from "../../../../Requests/adjustment";

interface IProps {
  taskId: number;
  adjusmentExeTab: string;
}

const ErrorsTable = ({ adjusmentExeTab, taskId }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          tableBoxClassName="!max-h-[500px]"
        />
      )}
      getDataTable={getExeStatusOrdersErrorsTable}
      initialSearchParameters={{ taskId, adjusmentExeTab }}
      refreshTableTime={10000}
    />
  );
};

export default ErrorsTable;
